import { useState } from "react";
import styled, { createGlobalStyle } from "styled-components";
import Formula from "./Formula";
import Result from "./Result";
import Button from "./Button";
import { numbers, operators, buttons } from "../helpers";
import Poppins from "../fonts/Poppins/Poppins-Regular.ttf";

const GlobalStyle =  createGlobalStyle`
  html, body {
    margin:0;
    padding:0;
    background-color: #c0c0c0;
  }

  @font-face {
    font-family: Poppins;
    src: url(${Poppins});
  }

  html {
    box-sizing: border-box;
  }

  *, *::before, *::after {
    box-sizing: inherit;
  }
`;

const OuterBox = styled.div`
  min-height: 100vh;
  display:flex;
  justify-content: center;
  align-items: center;
`;

const InnerBox = styled.div`
  height: 590px;
  width: 360px;
  display:flex;
  flex-direction: column;
  background-color: #000;
  border-radius: 25px;
  padding: 20px;
  box-shadow: 0 35px 60px -15px rgba(0, 0, 0, 0.3);
`;

const DisplayDiv = styled.div`
  height: 150px;
  font-family:Poppins;
  & > * {
    display:flex;
    flex-direction:row-reverse;
  }
`;

const PadsDiv = styled.div`
  flex:1;
  display:flex;
  flex-wrap: wrap;
  align-content: flex-start;
  font-family: Poppins;
`;

const ButtonDiv = styled.div`
  width: 100%;
  display:flex;
  flex-wrap: wrap;
  color: white;
  font-size: 1.4rem;
`;

const NumbersDiv = styled(ButtonDiv)`
  width: 75%;
  font-size: 1.45rem;
`;

const OperatorDiv = styled(ButtonDiv)`
  width: 25%;
  font-size: 2.0rem;
`;

const App = () => {

  const [formula, setFormula] = useState("");
  const [result, setResult] = useState("");
  const [prev, setPrev] = useState("");
  const [calculated, setCalculated] = useState(false);

  const handleClick = (event) => {
    const newOperators = [...operators, "%"];
    let typed = event.currentTarget.innerText;

    if (newOperators.includes(prev) && newOperators.includes(typed)){
      backspace();
    }

    if (calculated && newOperators.includes(typed))
      setFormula(`${result}`);

    setCalculated(false);

    switch(typed){
      case "AC":
        return reset();
      case "CE":
        return backspace();
      case "=":
        return calculate();
      default:
        setFormula(currentFormula => `${currentFormula}${typed}`);
        setPrev(typed);
        break;
    }
  };

  const backspace = () => {
    setFormula(currentFormula => currentFormula.slice(0,-1));
    setPrev(formula[formula.length - 2] || "");
  }

  const reset = () => {
    setFormula("");
    setResult("");
    setPrev("");
    setCalculated(false);
  };

  const calculate = () => {
    setCalculated(true);
    try {
      /* eslint-disable-next-line */
      const evaluated = eval(formula);
      const fixed = evaluated.toFixed(2);
      if(Number.isInteger(evaluated)){
        setResult(evaluated);
      }
      else {
        setResult(fixed);
      }
    }
    catch(e) {
      setResult("Incorrect Expression");
    }
  };

  return (
    <>
      <GlobalStyle />
      <OuterBox>
        <InnerBox>
          <DisplayDiv>
            <Formula formula={formula} />
            <Result result={result} />
          </DisplayDiv>
          <PadsDiv>
            <ButtonDiv>
              {buttons.map(button => <Button handleClick={handleClick} key={button} type="feature" content={button}/>)}
            </ButtonDiv>
            <NumbersDiv>
              {numbers.map(number => <Button handleClick={handleClick} key={number} type="number" content={number} />)}
            </NumbersDiv>
            <OperatorDiv>
              {operators.map(operator => <Button handleClick={handleClick} key={operator} type="operator" content={operator}/>)}
            </OperatorDiv>
          </PadsDiv>
        </InnerBox>
      </OuterBox>
    </>
  );
};

export default App;